import Vue from 'vue'
import cookies from 'vue-cookies'

Vue.prototype.$cookies = cookies;

Vue.prototype.$global = {
    AppName: "金山办公安全应急响应中心",
    AppDesc: '金山办公安全应急响应中心（Kingsoft Office Security Response Center，简称“WPSSRC”）作为金山办公面向广大用户收集安全漏洞及威胁情报公开平台，' +
        '携手互联网安全领域中的力量共同发现潜在的安全威胁，帮助金山办公提升产品和业务的安全性；' +
        '与此同时，积极与安全专家们建立联系，建设互联网生态安全，共同守护亿万金山办公用户的信息安全。',
    PageSize: 10,
    AppendixSize: 50 * 1024 * 1024,
    ImageSize: 1024 * 1024,
    //
    Markdown2Html(v) {
        let html = v;
        html = html.replace(')![', ')\n![');
        // 处理图片问题
        html = html.toString();
        let images = html.match(/!\[(.+)\]\((\/api\/src\/files\/)(.+)\)/g);
        if (images) {
            for (let img of images) {
                let url = img.match(/\(.*\)$/);
                if (url) {
                    url = url.toString();
                    url = url.replace('(', '');
                    url = url.replace(')', '');
                    html = html.replace(img, `<a href="${url}" target="_blank"><img src="${url}" alt=""/></a>`)
                }
            }
        }
        // 处理 \n 问题
        html = html.replace(/\\n/g, "\n");
        html = html.replace(/&#x60;/g, "`");
        return html;
    },
    // Html编码转义
    Html2Escape(v) {
        v = v.toString();
        v = v.replace(')![', ')\n![');
        return v.replace(/[<>&"`]/g, function (c) {
            return {
                '<': '&lt;',
                '>': '&gt;',
                '&': '&amp;',
                '"': '&quot;',
                '`': '&#x60;'
            }[c];
        });
    },
    MarkdownUnescape(v) {
        v = v.toString();
        v = v.replace(/&#0x60;/g, '`');
        v = v.replace(/&#0x27;/g, "'");
        v = v.replace(/&#0x22;/g, '"');
        v = v.replace(/&#0x0A;/g, '\n');
        v = v.replace(/&#0x0D;/g, '\r');
        v = v.replace(/&#0x5C;/g, '\\');
        v = v.replace(/&amp;/g, '&');
        return v;
    },
    Get(name) {
        let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        let r = location.search.substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return 'null';
    }
};
